import { Link } from "react-router-dom";

const techLabels = {
  html: "HTML",
  css: "CSS",
  js: "JavaScript",
  react: "React",
  figma: "Figma",
  fluig: "Fluig",
  php: "PHP",
  laravel: "Laravel",
  sass: "Sass",
  jquery: "jQuery",
  sqlserver: "SQL Server",
  twilio: "Twilio",
  node: "Node JS",
  rm: "TOTVS RM",
};

export default function CardProject({
  slug,
  nameProject,
  description,
  technologies = [],
  tag,
  thumbLabel,
  featured = false,
}) {
  return (
    <Link
      to={`/projeto/${slug}`}
      className={`pc sectionAnimate${featured ? " pw" : ""}`}
      onClick={() => sessionStorage.setItem("fromProject", "true")}
    >
      <div className="pthumb">
        <div className="pgrid" />
        <div className="pglow" />
        <span className="pthumb-txt">{thumbLabel}</span>
      </div>
      <div className="pbody">
        <span className="ptag">{tag}</span>
        <h3 className="pname">{nameProject}</h3>
        <p className="pdesc">{description}</p>
        <div className="ptechs">
          {technologies.map((tech) => {
            const label = techLabels[tech.toLowerCase()];
            return label ? (
              <span key={tech} className="tg">
                {label}
              </span>
            ) : null;
          })}
        </div>
      </div>
    </Link>
  );
}
